// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"TitleBlock_titleContainer__b_4WQ","fullWidth":"TitleBlock_fullWidth__ckfD_","leftAlign":"TitleBlock_leftAlign___cxs6"};